// Lightweight message count for the current record, so the dock rail + tab can
// signal "there's correspondence here". Polls on the same 45s cadence as
// notifications. ponytail: a full list call for a count; swap for a HEAD/count
// endpoint if it ever shows up on a hot path.
import { useEffect, useState } from "react";
import { listMessagesApi } from "../lib/brain-api";
import type { CorrespondenceTarget } from "../lib/source-registry";

const POLL_MS = 45_000;

export function useCorrespondenceCount(target: CorrespondenceTarget | null): number {
  const [count, setCount] = useState(0);
  const source = target?.source;
  const sourceId = target?.sourceId;

  useEffect(() => {
    if (!source || !sourceId) {
      setCount(0);
      return;
    }
    let alive = true;
    const load = () =>
      listMessagesApi(source, sourceId)
        .then((msgs) => { if (alive) setCount(msgs.length); })
        .catch(() => { if (alive) setCount(0); });
    void load();
    const t = setInterval(load, POLL_MS);
    return () => { alive = false; clearInterval(t); };
  }, [source, sourceId]);

  return count;
}
